import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { P3Configuration } from 'models/interfaces/P3Configurations';

export const GET_P3_CONFIGURATIONS = gql`
  query GetP3Configurations {
    p3Configurations {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      tgrams_id
      companyName
      campaign_status_id
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
      created_by
      regions {
        p3_configuration_id
        region_code
        name
        last_updated_by
        last_updated_date
        created_date
        created_by
      }
      categories {
        p3_configuration_id
        category_id
        category_name
        national_purchased_rank_points
        national_earned_rank_points
        national_bonus_rank_points
        national_total_rank_points
        national_estimated_rank
        regional_purchased_rank_points
        regional_earned_rank_points
        regional_bonus_rank_points
        regional_total_rank_points
        regional_estimated_ranks
        has_national_preview_ad
        has_regional_preview_ad
        last_updated_by
        last_updated_date
        created_by
      }
    }
  }
`;
export const GET_P3_CONFIGURATIONS_REDUCED = gql`
  query GetP3Configurations {
    p3ConfigurationsWithTgramIds {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      tgrams_id
      companyName
      campaign_status_id
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
      created_by
    }
    p3ConfigurationsWithOutTgramIds {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      tgrams_id
      companyName
      campaign_status_id
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
      created_by
    }
  }
`;
export const GET_P3_CONFIGURATION = gql`
  query GetP3Configuration($p3_configuration_id: String!) {
    p3Configuration(p3_configuration_id: $p3_configuration_id) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
      created_by
      regions {
        p3_configuration_id
        region_code
        name
        last_updated_by
        last_updated_date
        created_date
        created_by
      }
      categories {
        p3_configuration_id
        category_id
        category_name
        national_purchased_rank_points
        national_earned_rank_points
        national_bonus_rank_points
        national_total_rank_points
        national_estimated_rank
        regional_purchased_rank_points
        regional_earned_rank_points
        regional_bonus_rank_points
        regional_total_rank_points
        regional_estimated_ranks
        has_national_preview_ad
        has_regional_preview_ad
        last_updated_by
        last_updated_date
        created_by
      }
    }
  }
`;

export const DUPLICATE_P3CONFIGURATION_MUTATION = gql`
  mutation DuplicateP3Configuration(
    $p3_configuration_id: String
    $newConfigurationId: String
    $newCampaignId: String
    $tgramsId: String
  ) {
    duplicateP3Configuration(
      p3_configuration_id: $p3_configuration_id
      newConfigurationId: $newConfigurationId
      newCampaignId: $newCampaignId
      newTgramsId: $tgramsId
    ) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
    }
  }
`;

export const DELETE_P3CONFIGURATION_MUTATION = gql`
  mutation DeleteP3Configuration($p3_configuration_id: String) {
    deleteP3Configuration(p3_configuration_id: $p3_configuration_id)
  }
`;
export const DELETE_P3CONFIGURATION_FROM_CAMPAIGN_MUTATION = gql`
  mutation DeleteP3ConfigurationFromCampaign(
    $p3_configuration_id: String
    $p3_campaign_id: String) {
    deleteP3ConfigurationFromCampaign(
      p3_configuration_id: $p3_configuration_id
      p3_campaign_id: $p3_campaign_id
      )
  }
`;
export const ASSIGN_P3CONFIGURATION_MUTATION = gql`
  mutation SaveAssignP3Configuration(
    $p3_configuration_id: String
    $tgrams_id: String
    $name: String
  ) {
    saveAssignP3Configuration(
      p3_configuration_id: $p3_configuration_id
      tgrams_id: $tgrams_id
      name: $name
    )
  }
`;

export const SAVE_P3CONFIGURATION_MUTATION = gql`
  mutation SaveP3Configuration($p3Configuration: P3ConfigurationInput) {
    saveP3Configuration(p3Configuration: $p3Configuration) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
    }
  }
`;
interface P3ConfigurationsQueryResults {
  p3Configurations: P3Configuration[];
  p3ConfigurationsWithTgramIds: P3Configuration[];
  p3ConfigurationsWithOutTgramIds: P3Configuration[];
}

interface P3ConfigurationsContainerProps {
  children: (props: any) => any;
}

// class ConfigurationsQuery extends Query<P3ConfigurationsQueryResults> {}

const P3ConfigurationsContainer: React.FunctionComponent<P3ConfigurationsContainerProps> = ({
  children
}) => {
  return (
    <Query<P3ConfigurationsQueryResults>
      query={GET_P3_CONFIGURATIONS_REDUCED}
      fetchPolicy="cache-and-network"
    >
      {({
        data: { p3ConfigurationsWithTgramIds, p3ConfigurationsWithOutTgramIds } = {
          p3ConfigurationsWithTgramIds: [],
          p3ConfigurationsWithOutTgramIds: []
        },
        loading,
        error,
        client
      }) => {
        if (loading || error) {
          return null;
        }
        const p3Configurations = [
          ...p3ConfigurationsWithOutTgramIds,
          ...p3ConfigurationsWithTgramIds
        ];
        const updateConfigurationsCache = () => {
          const Assigned: any[] = p3ConfigurationsWithTgramIds;
          const Unassigned: any[] = p3ConfigurationsWithOutTgramIds;

          const data: any = {
            configurationsPageCache: {
              Assigned,
              Unassigned
            }
          };

          client.writeData({ data });
        };

        updateConfigurationsCache();

        return children({
          p3Configurations,
          loading,
          error: error
        });
      }}
    </Query>
  );
};

export default P3ConfigurationsContainer;
